import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2,
    CloudSnow,
    CloudSun,
    CloudSunRain} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, createNewMockTopic } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import CustomCanvasConfetti from "../../../UI/Confetti";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const CreateNewTopicPopUp= ({quizObject,currentTopic,setCloseNewTopicPopUp,menuOrder,returnTopicObject})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [activeLevel, setActiveLevel] = useState(currentTopic?.difficulty_level?currentTopic?.difficulty_level:"easy");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [topicName, setTopicName] = useState(currentTopic?.topic_name?currentTopic?.topic_name:"");
        const [topicDescription, setTopicDescription] = useState(currentTopic?.topic_description?currentTopic?.topic_description:"");
        
        const [quizID, setQuizID] = useState("");
     
        const [fireConfetti, setFireConfetti] = useState(false);
        
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
      
     
     },[])
  
   
     const handleCreateNewQuizTopic=()=>{
     
     
     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTopic({topicName:topicName,topicDescription:topicDescription,difficultyLevel:activeLevel,
                   postParent:quizObject?.ID,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:menuOrder,
                   editType:"create",appToken:AppToken,appId:appId}
                   ));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){     
           if(response?.topic){
           
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
       setFireConfetti(true) 
       setTimeout(()=>{
        returnTopicObject(response?.topic?.topic)
          setCloseNewTopicPopUp(false)
            
         },100)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
     const handleUpdateFieldQuizTopic=(field,value)=>{
     
     
     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTopic({
                   postParent:quizObject?.ID,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",topicId:currentTopic?.id,
                   editType:"updateField",appToken:AppToken,appId:appId,field:field,value:value}
                   ));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){  console.log(response)   
           if(response?.topic){
           
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
       
   
       return <>
       
   
 
 
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>setCloseNewTopicPopUp(false)} className="appDesignPopUpOpacity"  style={{zIndex:98,cursor:"pointer"}}> </div>
        <div   className="AreYouSurePopUp" style={{height:"440px",borderRadius: '20px',zIndex:99}}> 
             {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}
        <h2 align="center" >  {currentTopic?.id?" Update ":"Add New "}  <span className="coloredTextV1" >Topic</span>  {currentTopic?.id?" Info ":"To Quiz"}  </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"290px",overflowX:"hidden"}}>

    <div className="">
    
  
   <div  className="" >
<div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Topic Title`} type="text"
  rows={1} name="courseTitle" value={topicName} onChange={(e)=>{setTopicName(e.target.value)
    setTimeout(()=>{ if(currentTopic?.id){handleUpdateFieldQuizTopic("topic_name",e.target.value)} },1000)  }} />
 </div><div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Topic Description`} type="text"
  rows={2} name="courseTitle" value={topicDescription} onChange={(e)=>{setTopicDescription(e.target.value);
   setTimeout(()=>{ if(currentTopic?.id){handleUpdateFieldQuizTopic("topic_description",e.target.value)}},1000)   }
  } />
 </div></div>
 <div style={{display:"flex",justifyContent:"space-between"}}>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setActiveLevel("easy");setTimeout(()=>{
     if(currentTopic?.id){handleUpdateFieldQuizTopic("difficulty_level","easy")}},1000)}}  style={{position:"relative",border:`${activeLevel=="easy"?"2px solid rgba(144, 202, 249,1)":"2px solid #fff"}`,background:"rgba(144, 202, 249,0.21)",color:"#222222",width:"150px",cursor:"pointer",zIndex:99999,height:"45px",display:"flex",justifyContent:"left"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <CloudSnow size={24} color={"#222222"}/> <div style={{fontSize:"16px",padding:"4px"}}>Easy</div></button>
 
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setActiveLevel("medium");setTimeout(()=>{
     if(currentTopic?.id){handleUpdateFieldQuizTopic("difficulty_level","medium")}},1000)}}  style={{position:"relative",border:`${activeLevel=="medium"?"2px solid rgba(144, 202, 249,1)":"2px solid #fff"}`,background:"rgba(144, 202, 249,0.21)",color:"#222222",width:"150px",cursor:"pointer",zIndex:99999,height:"45px",display:"flex",justifyContent:"left"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <CloudSun size={24} color={"#222222"}/> <div style={{fontSize:"16px",padding:"4px"}}>Medium</div></button>
 
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setActiveLevel("hard");setTimeout(()=>{
     if(currentTopic?.id){handleUpdateFieldQuizTopic("difficulty_level","hard")}},1000)}}  style={{position:"relative",border:`${activeLevel=="hard"?"2px solid rgba(144, 202, 249,1)":"2px solid #fff"}`,background:"rgba(144, 202, 249,0.21)",color:"#222222",width:"150px",cursor:"pointer",zIndex:99999,height:"45px",display:"flex",justifyContent:"left"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <CloudSunRain size={24} color={"#222222"}/> <div style={{fontSize:"16px",padding:"4px"}}>Difficult</div></button>
 
</div>


</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>{currentTopic?.id?<div></div>:""}<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>setCloseNewTopicPopUp(false)}    className=" CoursesPreviewTopBtn" style={{background:"#222222",color:"#fff",}}
   type="submit"
 >{currentTopic?.id?"Close":"Cancel"}  </button>
 {!currentTopic?.id?<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewQuizTopic()}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To  Create"} </button>:""}

</div> 
</div>

     </div>

     <div>
     </div>

    
     
     </>


}
export default CreateNewTopicPopUp;